import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { faq_pdf } from "Constants/courses";

const BrochureNotAvailableModal = ({ show, onHide, courseName }) => {
  /* const handleContactUs = () => {
    window.open(
      `mailto:contactus-trustedge@cse.iib.ac.in?subject=Brochure Request for ${courseName}`,
      '_blank'
    );
    onHide();
  }; */

  const handleFAQ = () => {
    window.open(
      faq_pdf,
      '_blank',
      'noopener,noreferrer'
    );
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-center w-100">
          <i className="fas fa-file-pdf text-primary me-2" style={{ fontSize: '1.5rem' }}></i>
          Brochure Request
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <div className="mb-3">
          <i className="fas fa-info-circle text-info" style={{ fontSize: '3rem' }}></i>
        </div>
        <h5 className="mb-3">Brochure Coming Soon!</h5>
        <p className="mb-2">
          The brochure for <strong>"{courseName}"</strong> is currently being prepared.
        </p>
        <p className="text-muted">
          In the meantime, feel free to contact us for detailed course information.
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="outline-secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="outline-primary" onClick={handleFAQ}>
          View FAQ
        </Button>
        {/* <Button variant="primary" onClick={handleContactUs}>
          <i className="fas fa-envelope me-2"></i>
          Contact Us
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default BrochureNotAvailableModal;